<template>
    <div class="container">
        <div class="letter bounce letter-1">H</div>
        <div class="letter bounce letter-2">a</div>
        <div class="letter bounce letter-3">r</div>
        <div class="letter bounce letter-4">a</div>
        <div class="letter bounce letter-5">m</div>
        <div class="letter bounce letter-6">e</div>
        <div class="letter bounce letter-7">b</div>
        <div class="letter bounce letter-8">a</div>
        <div class="letter bounce letter-9">y</div>
    </div>
</template>

<style scoped>
.container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.letter {
    font-size: 18px;
    font-family: 'Dogica Bold', Helvetica, Arial;
    letter-spacing: -2px;
    display: inline-block;
}

.bounce {
    animation-name: bounce;
    animation-timing-function: cubic-bezier(0.28, 0.84, 0.42, 1);
    animation-duration: 2s;
    animation-iteration-count: infinite;
}

.letter-1 {
    animation-delay: 0ms;
}

.letter-2 {
    animation-delay: 100ms;
}

.letter-3 {
    animation-delay: 200ms;
}

.letter-4 {
    animation-delay: 300ms;
}

.letter-5 {
    animation-delay: 400ms;
}

.letter-6 {
    animation-delay: 500ms;
    color: #bd3c39;
}

.letter-7 {
    animation-delay: 600ms;
    color: #2962cb;
}

.letter-8 {
    animation-delay: 700ms;
    color: #ebb23d;
}

.letter-9 {
    animation-delay: 800ms;
    color: #91b73d;
}

@media only screen and (max-width: 1400px) {
    .letter {
        font-size: 15px;
    }
}

@media only screen and (max-width: 1300px) {
    .letter {
        font-size: 13px;
    }
}

@keyframes bounce {
    0% {
        transform: scale(1, 1) translateY(0);
    }
    10% {
        transform: scale(1.2, 0.8) translateY(0);
    }
    30% {
        transform: scale(0.8, 1.2) translateY(-15px);
    }
    50% {
        transform: scale(1.1, 0.9) translateY(0);
    }
    57% {
        transform: scale(0.9, 1.1) translateY(-3px);
    }
    64% {
        transform: scale(1.05, 0.95) translateY(0);
    }
    100% {
        transform: scale(1, 1) translateY(0);
    }
}
</style>
